module Hereabout.Navigator.Share
  ( shareUrl
  )
  where

import Prelude

import Effect (Effect)

foreign import _share :: String -> Effect Unit

shareUrl :: String -> Effect Unit
shareUrl = _share

